// extracted by mini-css-extract-plugin
export var alignBaseline = "_c-9";
export var alignCenter = "_c-5";
export var alignFlexEnd = "_c-7";
export var alignFlexStart = "_c-6";
export var alignSelfBaseline = "_c-e";
export var alignSelfCenter = "_c-a";
export var alignSelfFlexEnd = "_c-c";
export var alignSelfFlexStart = "_c-b";
export var alignSelfStretch = "_c-d";
export var alignStretch = "_c-8";
export var column = "_c-2";
export var columnReverse = "_c-4";
export var flex = "_c-0";
export var justifyCenter = "_c-f";
export var justifyFlexEnd = "_c-h";
export var justifyFlexStart = "_c-g";
export var justifySpaceAround = "_c-j";
export var justifySpaceBetween = "_c-i";
export var justifySpaceEvenly = "_c-k";
export var row = "_c-1";
export var rowReverse = "_c-3";
export var wrapNowrap = "_c-m";
export var wrapWrap = "_c-l";
export var wrapWrapReverse = "_c-n";